const DEV_API_FALLBACK = 'http://localhost:8001';

export function getApiBaseUrl(env = process.env) {
  const configured = (env.REACT_APP_BACKEND_URL || '').trim().replace(/\/$/, '');
  if (configured) return configured;
  if (env.NODE_ENV === 'production') return '';
  return DEV_API_FALLBACK;
}

export const API_URL = getApiBaseUrl();
